<template>
  <b-container>
    <b-row class="headline" align-v="center" v-if="video">
      <b-col>
        <h4>{{ video.title }}</h4>
      </b-col>
    </b-row>

    <b-row v-if="video">
      <b-col class="player-col">
        <Player v-model="video"
                :videos="related"
                :autoplay="true"
                :pageUrl="$route.fullPath"></Player>
      </b-col>
    </b-row>

    <VideoInfo :video="video" v-if="video" :expandComments="true" />

  </b-container>
</template>

<style scoped lang="scss">
  @import '@/assets/custom.scss';
  @import '~bootstrap/scss/mixins/_breakpoints.scss';

  .container {
    margin-top: 2em;
    max-width: unset;
  }

  .headline {
    margin-bottom: 1em;

    /deep/ button {
      padding: 0 1em;
      border-radius: 4px !important;
    }
  }

</style>

<script>
import { mapGetters } from 'vuex'

import FontAwesomeIcon from '@fortawesome/vue-fontawesome'
import Player from '@/components/widgets/Player'
import VideoInfo from '@/components/widgets/VideoInfo'
import Comments from '@/components/widgets/Comments'
import UserList from '@/components/widgets/UserList'

import { songHelpers, profileHelpers } from '@/store/helpers'

export default {
  name: 'VideoDetail',
  components: {
    FontAwesomeIcon,
    Player,
    VideoInfo,
    Comments,
    UserList
  },
  data () {
    return {
      video: null,
      related: []
    }
  },
  computed: {
    isMyVideo () {
      return (this.currentUser.artist_id && this.video.artist.id === this.artist.id)
    },
    ...mapGetters('profile', ['currentUser']),
    ...mapGetters('artist', ['artist'])
  },
  created () {
    this.fetchData()
  },
  watch: {
    '$route': 'fetchData',
    'video': 'updateRoute'
  },
  methods: {
    async fetchData () {
      const params = this.$route.params
      const relatedIds = this.$route.query.related

      if (this.video && this.video.id === +params.id) return

      try {
        this.video = await this.$store.dispatch('song/getSong', {id: params.id})
      } catch (e) {
        let message = 'Error getting video information'
        if (e.response && e.response.status === 404) message = 'Video no longer exists'
        this.$store.dispatch('flash/showMessage', { message, type: 'error' })
        this.$router.replace({'name': 'discover'})
        return
      }

      // If we have related video IDs, use those, otherwise list artist's videos
      const relatedFilter = relatedIds ? {related: relatedIds} : {artist: this.video.artist.id}
      const relatedResponse = await this.$store.dispatch('song/listSongs', relatedFilter)

      // If we have related video IDs, we want all the results, otherwise just a first batch is fine
      this.related = relatedIds ? await relatedResponse.all() : relatedResponse.results
    },
    updateRoute () {
      const route = this.$route

      if (!this.video || this.video.id === +route.params.id) return

      this.$router.push({
        name: route.name,
        meta: route.meta,
        params: { id: this.video.id },
        query: route.query
      })
    },
    ...songHelpers,
    ...profileHelpers
  }
}
</script>



// WEBPACK FOOTER //
// src/components/pages/artist/VideoDetail.vue